import React from 'react';
import classNames from 'classnames';
import { useStore } from 'effector-react';
import { ImageType, type LibItemSysIcon } from '@types';
import Image from '@components/Image';
import { $libSelected } from '../stores/libSelected';
import onItemClick from '../actions/onItemClick';

type Props = {
  index: number;
  size: number;
  data: LibItemSysIcon;
};

export function IconItem({ data, index, size }: Props) {
  const active = useStore($libSelected).includes(index);
  const { url } = data;

  return (
    <div
      className={classNames(
        'relative mx-5 mb-15 flex h-80 w-80 cursor-pointer items-center justify-center rounded bg-black-gray',
        { 'ring-2 ring-inset ring-orange': active }
      )}
      onClick={() => onItemClick(index)}
    >
      <Image
        type={ImageType.sysMedia}
        src={url}
        style={{
          width: size,
          height: size,
        }}
      />
    </div>
  );
}
